export const ALL_SEATS_SOLD = "ALL_SEATS_SOLD";
export const AVAILABLE = "AVAILABLE";
export const DEPARTED = "DEPARTED";
export const INVALID_WITH_DEPART_DATE = "INVALID_WITH_DEPART_DATE";
export const INVALID_WITH_RETURN_DATE = "INVALID_WITH_RETURN_DATE";
export const SOLD_OUT = "Sold out";
export const TOO_CLOSE_TO_DEPARTURE_DOMESTIC = "TOO_CLOSE_TO_DEPARTURE_DOMESTIC";
export const TOO_CLOSE_TO_DEPARTURE_INTERNATIONAL = "TOO_CLOSE_TO_DEPARTURE_INTERNATIONAL";
export const UNAVAILABLE = "UNAVAILABLE";
